import { Card } from '@salecycle/experimental/Card/Card';
import { T } from '@salecycle/experimental/Typography/Typography';
import { Button, Image } from '@salecycle/ui-component-library';
import { useCallback, useState } from 'react';
import { useTheme } from 'styled-components';
import { CreateCampaignModal } from './CreateCampaignModal/CreateCampaignModal';
import { useTranslation } from 'react-i18next';

export const EmptyListView = () => {
  const { t } = useTranslation('campaigns');
  const theme = useTheme();

  const [openCreateModal, setOpenCreateModal] = useState(false);

  const toggleModal = useCallback(() => setOpenCreateModal(!openCreateModal), [openCreateModal]);

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 50 }}>
        <Card
          shadowColour={theme.designToken.brandShadowBlue}
          style={{
            display: 'flex',
            flexDirection: 'column',
            width: 651,
            height: 608,
            alignItems: 'center',
            padding: `${theme.designToken.spacing8} 120px ${theme.designToken.spacing9} 120px`,
            gap: theme.designToken.spacing4,
          }}
        >
          <Image src="/images/campaign_types/bulk-retargeting.svg" />
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: theme.designToken.spacing5,
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'center',
                gap: theme.designToken.spacing4,
              }}
            >
              <T variant="headingH1" style={{ margin: 0 }}>
                {t('bulkRetargetingCampaigns.heading')}
              </T>
              <T variant="body2">{t('bulkRetargetingCampaigns.emptyList.body')}</T>
            </div>
            <Button
              variation="primary"
              style={{ width: 160 }}
              onClick={toggleModal}
              aria-label={t('bulkRetargetingCampaigns.emptyList.buttonAria')}
            >
              {t('bulkRetargetingCampaigns.emptyList.buttonLabel')}
            </Button>
          </div>
        </Card>
      </div>
      <CreateCampaignModal isOpen={openCreateModal} onCloseButtonClicked={toggleModal} />
    </>
  );
};
